var isArrayLike = require('./type/is-array-like');

function toArray(value) {
  return isArrayLike(value) ? Array.prototype.slice.call(value) : [];
}

module.exports = toArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/to-array.js
// module id = 37
// module chunks = 0 1 2